export default __webpack_public_path__ + "static/media/appLogo.b408b9ef.png";